<template>
	<chart-bar :chartData="chartData" :options="options" />
</template>
<script>
	import ChartBar from './chart-bar.vue';
	import { chunk } from 'lodash';

	export default {
		props: ['data', 'type'],
		inject: ['vigencia', 'mapVigencia'],
		components: { ChartBar },
		data() {
			return {
				colorDeptos: {
					'ESTALEIRO MAUA': '#f44336',
					'HOTEL AMERICANAS BARRA': '#9c27b0',
					'HOTEL COMFORT MACAE': '#673ab7',
					'HOTEL H NITERIO': '#e91e63',
					'HOTEL ROYAL ATLANTICA MACAE': '#00bcd4',
					'HOTEL ROYAL MACAE': '#009688',
					'HOTEL TULIP INN CAMPOS': '#4caf50',
					'HOTEL WINDSOR GUANABARA': '#00a65a',
					'HOTEL WYNDHAM BARRA': '#2196f3',
					'PORTO DO ACU': '#ffeb3b',
					'PORTO DOCAS': '#ff9800',
					'TERMINAL GIRASSOL': '#ff5722',
					// '' : '#795548',
					// '' : '#9e9e9e',
					// '' : '#607d8b',
					// '' : '#00e676',
					// '' : '#c6ff00',
					// '' : '#880e4f'
				},
			};
		},

		computed: {
			chunkVigencia() {
				// return this.vigencia
				return chunk(this.vigencia, 6)[1];
			},
			options() {
				return {
					responsive: true,
					maintainAspectRatio: false,
					legend: {
						position: 'right',
					},
				};
			},
			chartData() {
				return {
					labels: this.chunkVigencia.map((item) => item.xDate),
					datasets: this.mountDataSets(this.type),
				};
			},
		},
		methods: {
			mountDataSets(type) {
				let datasets = [];
				for (let depto in this.colorDeptos) {
					datasets.push({
						label: depto,
						backgroundColor: 'rgba(0, 0, 0, 0)',
						borderColor: this.colorDeptos[depto],
						data: this.chunkVigencia.reduce((acc, item) => {
							const value = this.data[type].find(
								(itemData) =>
									itemData.event == item.date &&
									itemData.titulo == depto
							);

							if (value == null) acc.push(0);
							else acc.push(value.total);

							return acc;
						}, []),
					});
				}

				return this.claerData(datasets);
			},
			claerData(datasets) {
				return datasets.filter(
					(item) => JSON.stringify(item.data) != '[0,0,0,0]'
				);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/exames_dashboard/components/ordem-de-servico.vue